import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

interface ComingSoonProps {
  title?: string;
  subtitle?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  title = "Coming Soon", 
  subtitle = "This feature is currently under development." 
}) => {
  return (
    <div style={{ padding: '50px 20px', textAlign: 'center' }}>
      <Result
        status="info"
        title={title}
        subTitle={
          <div dangerouslySetInnerHTML={{ __html: subtitle }} />
        }
        extra={
          <Link to="/">
            <Button type="primary">Back to Home</Button>
          </Link>
        }
      />
    </div>
  );
};

export default ComingSoon; 